//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMoney } from '../../../../../../common/functions/helpers';
import { skipLoading } from '../../../../../../common/functions/loading';

import ExecucaoModal from './ExecucaoModal';

import ApuracaoFinalizadaTabela from './ApuracaoFinalizadaTabela';
import ApuracaoPendentesTabela from './ApuracaoPendentesTabela';
import NegociacoesAguardandoAprovacao from './NegociacoesAguardandoAprovacao';
import PagamentosLiquidadosTabela from './PagamentosLiquidadosTabela';

export default {
  components: {
    ApuracaoFinalizadaTabela,
    ApuracaoPendentesTabela,
    NegociacoesAguardandoAprovacao,
    ExecucaoModal,
    PagamentosLiquidadosTabela,
  },
  props: {
    parametros: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),

      limit: 5,
      filtros: {},
      competencia: null,
      cacheFiltros: {
        pendentes: {
          status: 'EM_PROCESSO_APURACAO',
        },
        finalizadas: {
          status: 'AGUARDANDO_PAGAMENTO',
        },
      },

      consolidado: {},
      competenciasPagamento: [],
      apuracoesFinalizadas: [],
      apuracoesPendentes: [],
      negociacoesAgAprovacao: [],

      paginasApuracoesFinalizadas: 0,
      paginasApuracoesPendentes: 0,
      paginasNegociacoesAgAprovacao: 0,

      carregado: false,
      carregandoBox: false,
      carregandoFinalizadas: false,
      carregandoPendentes: false,
      carregandoAgAprovacao: false,
    };
  },
  methods: {
    getMoney,
    requestCarregarPeriodos() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardNegociacaoResources.periodosCliente()
          .then((response) => {
            this.competenciasPagamento = response.data;
            if (this.competenciasPagamento.length === 0) {
              return;
            }
            this.competencia = this.competenciasPagamento[0].valor;
            this.filtros.competencia = this.competencia;
            resolve();
          })
          .catch(reject);
      });
    },
    requestCarregarConsolidadoPagamento() {
      if (!this.competencia) {
        return;
      }
      skipLoading();
      this.carregandoBox = true;
      this.dashboardPagamentoResources.consolidadoCliente(this.filtros)
        .then((response) => {
          this.carregandoBox = false;
          this.consolidado = response.data;
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoBox = false;
        });
    },
    requestCarregarApuracoesFinalizadas(pagina = 0, status = null) {
      if (!this.competencia) {
        return;
      }
      skipLoading();
      this.carregandoFinalizadas = true;

      if (status !== null) {
        this.cacheFiltros.finalizadas.status = status;
      }

      const mesclado = Object.assign(this.cacheFiltros.finalizadas, this.filtros);
      mesclado.numeroPagina = pagina;
      mesclado.tamanhoPagina = this.limit;

      this.dashboardApuracaoResources.apuracoesFinalizadas(mesclado)
        .then((response) => {
          const data = response.data;

          this.carregandoFinalizadas = false;
          this.apuracoesFinalizadas = data.resposta;

          const qtdeRegistros = data.quantidadeRegistrosPagina;
          this.paginasApuracoesFinalizadas = Math.ceil(qtdeRegistros / this.limit);
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoFinalizadas = false;
        });
    },
    requestCarregarApuracoesPendentes(pagina = 0, status = null) {
      if (!this.competencia) {
        return;
      }
      skipLoading();
      this.carregandoPendentes = true;

      if (status !== null) {
        this.cacheFiltros.pendentes.status = status;
      }

      const mesclado = Object.assign(this.cacheFiltros.pendentes, this.filtros);
      mesclado.numeroPagina = pagina;
      mesclado.tamanhoPagina = this.limit;

      this.dashboardApuracaoResources.apuracoesPendentes(mesclado)
        .then((response) => {
          const data = response.data;

          this.carregandoPendentes = false;
          this.apuracoesPendentes = data.resposta;

          const qtdeRegistros = data.quantidadeRegistrosPagina;
          this.paginasApuracoesPendentes = Math.ceil(qtdeRegistros / this.limit);
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoPendentes = false;
        });
    },
    requestCarregarNegociacoesAgAprovacao(pagina = 0, filtrosParametros = null) {
      if (!this.competencia) {
        return;
      }
      skipLoading();
      this.carregandoAgAprovacao = true;

      let filtrosNegociacoes = {};
      if (filtrosParametros !== null) {
        filtrosNegociacoes = Object.assign({}, filtrosParametros);
      } else {
        filtrosNegociacoes = Object.assign({}, this.filtros);
      }
      filtrosNegociacoes.numeroPagina = pagina;
      filtrosNegociacoes.tamanhoPagina = this.limit;

      this.dashboardNegociacaoResources.negociacoesAgAprovacao(filtrosNegociacoes)
        .then((response) => {
          const data = response.data;

          this.carregandoAgAprovacao = false;
          this.negociacoesAgAprovacao = data.resposta;

          const qtdeRegistros = data.quantidadeRegistrosPagina;
          this.paginasNegociacoesAgAprovacao = Math.ceil(qtdeRegistros / this.limit);
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoAgAprovacao = false;
        });
    },
    refreshDashboard() {
      this.$refs.apuracoesFinalizadas.refazPaginacao();
      this.$refs.apuracoesPendentes.refazPaginacao();
      this.$refs.negociacoesAgAprovacao.refazPaginacao();
      this.$refs.pagamentosLiquidados.refazPaginacao();

      this.filtros.competencia = this.competencia;

      this.requestCarregarConsolidadoPagamento();
      this.requestCarregarApuracoesFinalizadas();
      this.requestCarregarApuracoesPendentes();
      this.requestCarregarNegociacoesAgAprovacao();
    },
    filtrosPorParametros() {
      const filtros = {};
      if (this.parametros && this.parametros.idAcordo) {
        filtros.idAcordo = this.parametros.idAcordo;
      }
      return filtros;
    },
    exibirSidebar(idMeta) {
      this.$refs.execucaoModal.abrir(idMeta);
    },
    abreCarrega() {
      if (this.carregado) {
        return;
      }

      this.requestCarregarPeriodos()
        .then(() => {
          this.requestCarregarConsolidadoPagamento();
          this.requestCarregarApuracoesFinalizadas();
          this.requestCarregarApuracoesPendentes();
          this.requestCarregarNegociacoesAgAprovacao();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });

      this.carregado = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/DashboardAcompanhamento.vue?vue&type=script&lang=js&